import AbstractModalBaseController from '../../../../core/abstracts/controllers/modal-base-controller';

export default class AddWalletTemplateModalController extends AbstractModalBaseController {

    constructor($scope, $injector, $uibModalInstance) {
        super($scope, $injector, $uibModalInstance);

        this.api = this.injector.get('$http');
        this.acl = this.injector.get('Acl');
        this.translate = this.injector.get('$translate');
        this.alert = this.injector.get('Alert');

        this.loading = true;

        this.currentAddType = 'new';
        this.availableTemplateTypes = [];
        this.existingTemplates = [];
        this.templateIdToDuplicateFrom = null;

        this._loadExistingTemplates()
            .then(() => {
                this.loading = false;
            })
    }

    updateTemplateIdToDuplicateFrom(newValue) {
        this.templateIdToDuplicateFrom = newValue;
        this.scope.$applyAsync();
    }

    submitCreate() {
        this.submitting = true;
        switch (this.currentAddType) {
            case 'new':
                this.api
                    .post('wallets/templates', {
                        name: 'New Wallet'
                    })
                    .then(({data}) => {
                        this.close({
                            walletTemplate: data.data
                        });
                    })
                    .catch(e => {
                        this.alert.handle(e)
                        this.submitting = false;
                    })
                break;
            case 'existing':
                this.api
                    .post(
                        `wallets/templates/${this.templateIdToDuplicateFrom}/duplicate`
                    )
                    .then(({data}) => {
                        this.close({
                            walletTemplate: data.data
                        });
                    })
                    .catch(e => {
                        this.alert.handle(e)
                        this.submitting = false;
                    })
                break;
        }
    }

    _loadExistingTemplates() {
        return this.api
            .post('fp/passbooks', {
                fields: [
                    'name',
                    'id'
                ],
                pagination: {
                    perPage: -1
                },
                sort: {
                    name: 'asc'
                }
            })
            .then(({data}) => {
                this.existingTemplates = _.map(data.data, (row) => {
                    return {
                        value: row.id,
                        label: row.name
                    }
                });
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/controllers/modals/add-wallet-template-modal.js